// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2fSgm","loaderWhite":"Loader_loaderWhite__1J4DC","loader-white":"Loader_loader-white__3Kw5t"};